export const environment = {
  production: true,
  apiUrl: 'https://dev.abletrace.ca/api/v1/', // DEV API URL (S167) - nginx proxies /api/ to dev Sails 1337
  decimalPlaces: 3
};
